export class State {
    public allChildStatesAllowed: boolean = false;
    public childStates?: { [key: string]: State };
}